<template>
  <v-card class="mr-3 mt-3">
    <v-toolbar
      flat
      class="accent"
      dark
      dense
    >
      <v-toolbar-title>Ihre Kalender</v-toolbar-title>
    </v-toolbar>

    <v-card-text
      class="pa-0 ma-0"
      v-if="this.info"
    >

      <!-- <v-card
          flat
          class="mr-3 mt-2 mb-3"
          >
            <v-card-text>
              <span class="">horst horst </span></v-card-text>

          </v-card> -->

      <v-list
        two-line
        class="ma-0 py-0"
        v-if="this.info.length > 0"
      >
        <template v-for="(item, abc) in this.info">

          <v-list-tile
            avatar
            :key="abc+'event'"
            class="py-2"
          >
            <v-list-tile-avatar>
              <v-icon
                :class="item.color ? item.color : 'accent'"
                :dark="!item.dunklertext"
              >event</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title> {{ item.name }}</v-list-tile-title>
              <v-list-tile-sub-title>
                <!-- am {{ new Date(item.date).toLocaleString('de-DE', { day: 'numeric', month: 'short' }) }} -->
              </v-list-tile-sub-title>

              <v-list-tile-sub-title class="text--primary">Am {{ new Date(item.updated_at.date).toLocaleString('de-DE', { day: 'numeric', month: 'short' }) }} aktualisiert</v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <span
                  v-for="(admin, i) in item.admins"
                  :key="i"
                >
                  {{ admin.name }}<span v-if="i != item.admins.length - 1">, </span>
                </span>
              </v-list-tile-sub-title>

            </v-list-tile-content>
          </v-list-tile>
          <v-divider :key="abc"></v-divider>
        </template>

      </v-list>

      <v-list three-line>
        <v-list-tile>

         
          <v-list-tile-content>
            <v-list-tile-title>Erklärung</v-list-tile-title>
            <v-list-tile-sub-title><strong>Wann</strong> wurde ein Kalender zuletzt aktualisiert.</v-list-tile-sub-title>
            <v-list-tile-sub-title><strong>Wer</strong> Ihre Kalender verwaltet.</v-list-tile-sub-title>
            
          </v-list-tile-content>
        </v-list-tile>

      </v-list>

    </v-card-text>

  </v-card>
</template>

<script>
export default {
  // props: ['events', 'intern'],
  props: {
    info: Array
  },
  data: () => ({
    active: null
  }),
  components: {
    // AnfrageVerstecken
  },
  computed: {
    // BetriebVorhanden: function () {
    //   if (this.$store.getters.authBetrieb) {
    //     if (this.$store.getters.authBetrieb.name) return true
    //   } else {
    //     return false
    //   }
    // }
  },
  mounted: function () {},
  methods: {}
}
</script>

<style>
</style>